import { createAsyncThunk } from '@reduxjs/toolkit'
import { User } from 'src/types/User'

export const setupUser = createAsyncThunk('auth/loginUser', (payload: User) => {
  return payload
})